import { Component } from '@angular/core';
import { TeacherCoursePlayListComponent } from "../../../components/courses-components/teacher-course-play-list/teacher-course-play-list.component";
import { courses } from '../../../providers/static-data';

@Component({
  selector: 'app-teacher-course-details',
  standalone: true,
  imports: [TeacherCoursePlayListComponent],
  templateUrl: './teacher-course-details.component.html',
  styleUrl: './teacher-course-details.component.css'
})
export class TeacherCourseDetailsComponent {
data = courses
}
